import * as React from 'react';
import Routes from './router';
import Poptire from './Poptire';
import Home from './Home';
class App extends React.Component{
  render(){
    return(
  
        <Routes></Routes>
      
    )
  }
}
export default App